import { DurationDropdownOptions, JobAmountSummaryAttributes } from '../types';

export enum SalesDetailsTypes {
  BY_TEAM_MEMBERS = 'team_members',
  BY_PAYMENT_METHODS = 'payment_methods'
}

export enum ManualPaymentMethodKeys {
  CASH = 'm-cash',
  CHECK = 'm-check',
  DIRECT_TRANSFER = 'm-direct-transfer',
  ZELLE = 'm-zelle',
  OTHER = 'm-other'
}

export enum ManualPaymentMethodValues {
  CASH = 'Cash',
  CHECK = 'Check',
  DIRECT_TRANSFER = 'Direct Transfer',
  ZELLE = 'Zelle',
  OTHER = 'Other'
}

export const ManualPaymentMethods = [
  {
    key: ManualPaymentMethodKeys.CASH,
    value: ManualPaymentMethodValues.CASH
  },
  {
    key: ManualPaymentMethodKeys.CHECK,
    value: ManualPaymentMethodValues.CHECK
  },
  {
    key: ManualPaymentMethodKeys.DIRECT_TRANSFER,
    value: ManualPaymentMethodValues.DIRECT_TRANSFER
  },
  {
    key: ManualPaymentMethodKeys.ZELLE,
    value: ManualPaymentMethodValues.ZELLE
  },
  {
    key: ManualPaymentMethodKeys.OTHER,
    value: ManualPaymentMethodValues.OTHER
  }
];

export const PaymentMethodsForInvoiceFilter = [
  {
    key: 'ach',
    value: 'ACH'
  },
  {
    key: 'affirm',
    value: 'Affirm'
  },
  {
    key: 'afterpay',
    value: 'Afterpay'
  },
  {
    key: 'applepay',
    value: 'Apple Pay'
  },
  {
    key: 'card',
    value: 'Credit / Debit Card'
  },
  {
    key: 'gpay',
    value: 'Google Pay'
  },
  {
    key: 'klarna',
    value: 'Klarna'
  },
  {
    key: 'm-cash',
    value: 'Manual-Cash'
  },
  {
    key: 'm-check',
    value: 'Manual-Check'
  },
  {
    key: 'm-direct-transfer',
    value: 'Manual-Direct Transfer'
  },
  {
    key: 'm-other',
    value: 'Manual-Other'
  },
  {
    key: 'm-zelle',
    value: 'Manual-Zelle'
  },
  {
    key: 'sunbit',
    value: 'Sunbit'
  }
];

export const TipInvoiceFilter = [
  {
    key: 'tip',
    value: 'Only with Tips'
  }
];

export const timelineFilterOptions = [
  { name: DurationDropdownOptions.TODAY },
  { name: DurationDropdownOptions.THIS_MONTH },
  { name: DurationDropdownOptions.LAST_MONTH },
  { name: DurationDropdownOptions.THIS_YEAR }
];

export const jobAmountFilterOptions = [
  { name: 'Jobs created', value: JobAmountSummaryAttributes.CREATED_AT },
  { name: 'Jobs scheduled', value: JobAmountSummaryAttributes.SCHEDULED_FROM }
];

export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=tech.scanpay.merchant&hl=en_IN&gl=US';
export const APP_STORE_URL = 'https://apps.apple.com/sg/app/scanpay-accept-payments/id1572936786';

export const validEmailRegex = new RegExp('^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]$');
export const validPhoneNumberRegex = new RegExp('^(\\+\\d{1,2}\\s)?\\(?\\d{3}\\)?[\\s.-]?\\d{3}[\\s.-]?\\d{4}$');
